import { render, staticRenderFns } from "./ForbiddenBanner.vue?vue&type=template&id=75905916"
import script from "./ForbiddenBanner.vue?vue&type=script&lang=js"
export * from "./ForbiddenBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports